<template>
  <page :load="init">
    <form>
      <message :messages="messages"></message>
      <v-card>
        <v-tabs v-model="tabMenu">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab>Backend Users</v-tab>
          <!-- <v-tab>Members</v-tab> -->
          <v-tab-item>
            <v-card-text>
              <v-layout row wrap>
                <v-flex lg4 xs12>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field data-vv-scope="passwordForm" v-int-mask="{intScale: 4}" v-model="passwordForm.usrPassExpiry" :label="labels.usrPassExpiry" type="tel" :error-messages="errors.collect('passwordForm.usrPassExpiry')" data-vv-name="usrPassExpiry" :data-vv-as="labels.usrPassExpiry" v-validate="'required|numeric|max_value:9999|min_value:0'"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field data-vv-scope="passwordForm" v-int-mask="{intScale: 2}" v-model="passwordForm.usrPassHistory" :label="labels.usrPassHistory" type="tel" :error-messages="errors.collect('passwordForm.usrPassHistory')" data-vv-name="usrPassHistory" :data-vv-as="labels.usrPassHistory" v-validate="'required|numeric|max_value:99|min_value:0'"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field data-vv-scope="passwordForm" v-int-mask="{intScale: 2}" v-model="passwordForm.usrPassLength" :label="labels.usrPassLength" type="tel" :error-messages="errors.collect('passwordForm.usrPassLength')" data-vv-name="usrPassLength" :data-vv-as="labels.usrPassLength" v-validate="'required|numeric|max_value:99|min_value:0'"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-checkbox data-vv-scope="passwordForm" v-model="passwordForm.usrPassMixCase" :error-messages="errors.collect('passwordForm.usrPassMixCase')" data-vv-name="usrPassMixCase" :data-vv-as="labels.usrPassMixCase" :label="labels.usrPassMixCase" hide-details></v-checkbox>
                      </v-flex>
                      <v-flex xs12>
                        <v-checkbox data-vv-scope="passwordForm" v-model="passwordForm.usrPassAlphaNum" :error-messages="errors.collect('passwordForm.usrPassAlphaNum')" data-vv-name="usrPassAlphaNum" :data-vv-as="labels.usrPassAlphaNum" :label="labels.usrPassAlphaNum" hide-details></v-checkbox>
                      </v-flex>
                      <v-flex xs12>
                        <v-checkbox data-vv-scope="passwordForm" v-model="passwordForm.usrPassSpecialCase" :error-messages="errors.collect('passwordForm.usrPassSpecialCase')" data-vv-name="usrPassSpecialCase" :data-vv-as="labels.usrPassSpecialCase" :label="labels.usrPassSpecialCase" hide-details></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions class="ma-2">
              <v-btn color="primary" :loading="loading" @click.prevent="doUpdateCheck" type="submit">
                Update
                <v-icon right>mdi-content-save</v-icon>
              </v-btn>
            </v-card-actions>
          </v-tab-item>
          <!-- <v-tab-item>
            <v-card-text>
              <v-layout row wrap>
                <v-flex lg4 xs12>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field data-vv-scope="memberPasswordForm" v-int-mask="{intScale: 4}" v-model="memberPasswordForm.membPassExpiry" :label="labels.membPassExpiry" type="tel" :error-messages="errors.collect('memberPasswordForm.membPassExpiry')" data-vv-name="membPassExpiry" :data-vv-as="labels.membPassExpiry" v-validate="'required|numeric|max_value:9999|min_value:0'"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field data-vv-scope="memberPasswordForm" v-int-mask="{intScale: 2}" v-model="memberPasswordForm.membPassHistory" :label="labels.membPassHistory" type="tel" :error-messages="errors.collect('memberPasswordForm.membPassHistory')" data-vv-name="membPassHistory" :data-vv-as="labels.membPassHistory" v-validate="'required|numeric|max_value:99|min_value:0'"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field data-vv-scope="memberPasswordForm" v-int-mask="{intScale: 2}" v-model="memberPasswordForm.membPassLength" :label="labels.membPassLength" type="tel" :error-messages="errors.collect('memberPasswordForm.membPassLength')" data-vv-name="membPassLength" :data-vv-as="labels.membPassLength" v-validate="'required|numeric|max_value:99|min_value:0'"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-checkbox data-vv-scope="memberPasswordForm" v-model="memberPasswordForm.membPassMixCase" :error-messages="errors.collect('memberPasswordForm.membPassMixCase')" data-vv-name="membPassMixCase" :data-vv-as="labels.membPassMixCase" :label="labels.membPassMixCase" hide-details></v-checkbox>
                      </v-flex>
                      <v-flex xs12>
                        <v-checkbox data-vv-scope="memberPasswordForm" v-model="memberPasswordForm.membPassAlphaNum" :error-messages="errors.collect('memberPasswordForm.membPassAlphaNum')" data-vv-name="membPassAlphaNum" :data-vv-as="labels.membPassAlphaNum" :label="labels.membPassAlphaNum" hide-details></v-checkbox>
                      </v-flex>
                      <v-flex xs12>
                        <v-checkbox data-vv-scope="memberPasswordForm" v-model="memberPasswordForm.membPassSpecialCase" :error-messages="errors.collect('memberPasswordForm.membPassSpecialCase')" data-vv-name="membPassSpecialCase" :data-vv-as="labels.membPassSpecialCase" :label="labels.membPassSpecialCase" hide-details></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions class="ma-2">
              <v-btn color="primary" :loading="loading" @click.prevent="doMembUpdateCheck" type="submit">
                Update
                <v-icon right>mdi-content-save</v-icon>
              </v-btn>
            </v-card-actions>
          </v-tab-item> -->
        </v-tabs>
      </v-card>
    </form>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      labels: {
        usrPassExpiry: 'Password Expiry (days)',
        usrPassHistory: 'No. of Password History to Keep',
        usrPassLength: 'Minimum password length',
        usrPassMixCase: 'Enforce Mixed Case in Password (A-a Z-z)',
        usrPassAlphaNum: 'Enforce Alphanumeric Password (123abc)',
        usrPassSpecialCase: 'Enforce Special Character in Password (@?.,)',
        membPassExpiry: 'Password Expiry (days)',
        membPassHistory: 'No. of Password History to Keep',
        membPassLength: 'Minimum password length',
        membPassMixCase: 'Enforce Mixed Case in Password (A-a Z-z)',
        membPassAlphaNum: 'Enforce Alphanumeric Password (123abc)',
        membPassSpecialCase: 'Enforce Special Character in Password (@?.,)'
      },
      passwordForm: {
        usrPassExpiry: null,
        usrPassHistory: null,
        usrPassLength: null,
        usrPassMixCase: null,
        usrPassAlphaNum: null,
        usrPassSpecialCase: null
      },
      memberPasswordForm: {
        membPassExpiry: null,
        membPassHistory: null,
        membPassLength: null,
        membPassMixCase: null,
        membPassAlphaNum: null,
        membPassSpecialCase: null
      },
      loading: false,
      menu: {},
      tabMenu: null
    }
  },
  methods: {
    async init() {
      const apiUrl = this.$store.state.adminUser.security.menu.passSettings
      if (apiUrl) {
        try {
          this.loading = true
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.passwordForm.usrPassExpiry = data.usrPassExpiry
            this.passwordForm.usrPassHistory = data.usrPassHistory
            this.passwordForm.usrPassLength = data.usrPassLength
            this.passwordForm.usrPassMixCase = data.usrPassMixCase
            this.passwordForm.usrPassAlphaNum = data.usrPassAlphaNum
            this.passwordForm.usrPassSpecialCase = data.usrPassSpecialCase

            this.memberPasswordForm.membPassExpiry = data.membPassExpiry
            this.memberPasswordForm.membPassHistory = data.membPassHistory
            this.memberPasswordForm.membPassLength = data.membPassLength
            this.memberPasswordForm.membPassMixCase = data.membPassMixCase
            this.memberPasswordForm.membPassAlphaNum = data.membPassAlphaNum
            this.memberPasswordForm.membPassSpecialCase = data.membPassSpecialCase

            // Extract the menu
            this.menu = extractMenu(result.data._links)
          }
          this.loading = false
        } catch (error) {
          this.loading = false
          throw error
        }
      } else {
        throw new Error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doUpdateCheck() {
      this.resetMessages()
      this.$validator.validateAll('passwordForm').then(result => {
        if (result) {
          this.doUpdate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doMembUpdateCheck() {
      this.resetMessages()
      this.$validator.validateAll('memberPasswordForm').then(result => {
        if (result) {
          this.doMembUpdate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.menu.updateUsers
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.put(apiURI, this.passwordForm)
          this.message(result.data)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doMembUpdate() {
      const apiURI = this.menu.updateMembers
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.put(apiURI, this.memberPasswordForm)
          this.message(result.data)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>
</style>
